export default "__VITE_ASSET__BiMouE7Z__"